import React from 'react';

export default () => {
    return <img
        alt="host"
        src="/static/images/icons/host.svg"
        style={{ width: '22px', height: '22px' }}
    />
}
